import { render, staticRenderFns } from "./PrecoCusto.vue?vue&type=template&id=ec3e17a6&scoped=true"
import script from "./PrecoCusto.vue?vue&type=script&lang=js"
export * from "./PrecoCusto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3e17a6",
  null
  
)

export default component.exports